module.exports = __webpack_public_path__ + "img/badge_standard.77902931.png";